<div *ngIf="disableEditing"
    style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>

<div class="modal-header bg-soft-info p-3">
    <h5 *ngIf="(newModel == true)" class="modal-title" id="exampleModalLabel" i18n="@@ContactPopUp_text_CreateContact">
        Create</h5>
    <h5 *ngIf="(newModel == false)" class="modal-title" id="exampleModalLabel" i18n="@@">
        Edit - {{model.fullName}}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>

<div class="card-body p-3">
    <div class="text-center">
        <div class="profile-user position-relative avatar-lg p-1">
            <div class="avatar-title bg-light rounded-circle">
                <img [src]="profileImageURL" class="avatar-md rounded-circle object-cover">
            </div>

            <div class="p-0 rounded-circle profile-photo-edit">
                <label 
                    *ngIf="disableInputs == false && (newModel === false && securityPermissionAccountUpdate) || (newModel === true && securityPermissionAccountCreate) && (disableEditing === false)"
                    for="profile-img-file-input" class="profile-photo-edit avatar-xs" (click)="fileUpload.click()"
                    type="multipart/form-data">
                    <span class="avatar-title rounded-circle bg-light text-body">
                        <i class="ri-camera-fill"></i>
                    </span>
                </label>
                <input accept="image/png, image/jpeg" style="display: none;"
                    class="file-input" type="file"
                    (change)="uploadPhotoDirectly(model, $event, enumEntityFileType.ProfilePhoto)"
                    #fileUpload>
            </div>
        </div>
    </div>
</div>

<div class="card-header mt-3">

    <ul ngbNav #customNav="ngbNav" [(activeId)]="activeTab"
        class="nav nav-tabs-custom card-header-tabs border-bottom-0 center justify-content-center"
        role="tablist">
        <li [ngbNavItem]="1" class="nav-item">
            <a ngbNavLink class="nav-link text-body " style="text-align: center" data-bs-toggle="tab" role="tab">
                <i class="fas fa-home"></i>
                <div i18n="@@ContactPopUp_tab_ContactDetails "> Contact Details</div>
            </a>
            <ng-template ngbNavContent>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="mb-3">
                            <label i18n="@@ContactPopUp_text_CompanyName">Organization Name</label>
                            <input required #corpName="ngModel" [patterns]="stringPattern" mask='%* %* %* %* %* %*'
                                [dropSpecialCharacters]="false"
                                [ngClass]="{ 'is-invalid': ((corpName.invalid && firstName.invalid)&& ((corpName.dirty || corpName.touched) || submitted == true))}"
                                class="form-control" type="text" placeholder="Enter Company Name"
                                i18n-placeholder="@@ContactPopUp_PlaceHolder_CompanyName" [disabled] = "disableInputs"
                                [(ngModel)]="model.companyName" (keypress)="modalEdited = true" />
                            <div *ngIf="((corpName.invalid && firstName.invalid) && ((corpName.dirty || corpName.touched) || submitted == true))"
                                class='invalidInputTextMessage'>
                                <div *ngIf="corpName.errors?.['required']">
                                    <div i18n="@@ContactPopUp_Error_CompanyNameRequired">Organization Name Required
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="mb-3">
                            <label i18n="@@ContactPopUp_text_firstName">First Name</label>
                            <input required #firstName="ngModel" [patterns]="stringPattern" mask='%* %* %* %* %* %*'
                                [dropSpecialCharacters]="false"  [disabled] = "disableInputs"
                                [ngClass]="{ 'is-invalid': ((firstName.invalid && corpName.invalid) && ((firstName.dirty || firstName.touched) || submitted == true))}"
                                class="form-control" type="text" placeholder="Enter First Name"
                                i18n-placeholder="@@ContactPopUp_PlaceHolder_firstName" [(ngModel)]="model.firstName"
                                (keypress)="modalEdited = true" />
                            <div *ngIf="((firstName.invalid && corpName.invalid) && ((firstName.dirty || firstName.touched) || submitted == true))"
                                class='invalidInputTextMessage'>
                                <div *ngIf="firstName.errors?.['required']">
                                    <div i18n="@@ContactPopUp_Error_firstNameRequired">First Name Required</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="mb-3">
                            <label i18n="@@ContactPopUp_text_lastName">Last Name</label>
                            <input required #lastName="ngModel" [patterns]="stringPattern" mask='%* %* %* %* %* %*'
                                [dropSpecialCharacters]="false" class="form-control" type="text" [disabled] = "disableInputs"
                                placeholder="Enter Last Name" i18n-placeholder="@@ContactPopUp_PlaceHolder_lastName"
                                [(ngModel)]="model.lastName" (keypress)="modalEdited = true" />
                        </div>
                    </div>
                    <div class="mb-3">
                        <div class="card-header align-items-center d-flex">
                            <h4 class="card-title mb-0 flex-grow-1" i18n="@@ContactPopUp_text_ContactInformation">
                                Contact Information</h4>
                        </div>
                        <div *ngIf="((email.invalid && phone.invalid && fax.invalid) && ((email.dirty || email.touched) || (email.dirty || phone.touched) ||(phone.dirty || fax.touched) || submitted == true))"
                            class='invalidInputTextMessage'> 
                            <div i18n="@@ContactPopUp_Error_ContactInformation">At least one point of contact is
                                required</div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="mb-3">
                            <label i18n="@@ContactPopUp_text_email">Email </label>
                            <input class="form-control" type="text" required [pattern]=emailPattern #email="ngModel"
                                [ngClass]="{ 'is-invalid': ((email.invalid && phone.invalid && fax.invalid) && ((email.dirty || email.touched) || submitted == true))}"
                                placeholder="Enter Email" i18n-placeholder="@@ContactPopUp_PlaceHolder_email" [disabled] = "disableInputs"
                                [(ngModel)]="model.email" (keypress)="modalEdited = true" />
                            <div *ngIf="(email.invalid && ((email.dirty || email.touched) || submitted == true))"
                                class='invalidInputTextMessage'>
                                <div *ngIf="email.errors?.['required'] else elseEmail">

                                </div>
                                <ng-template #elseEmail>
                                    <div *ngIf="email.invalid">
                                        <div i18n="@@ContactPopUp_Error_EmailInvalid">Email Invalid</div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="mb-3">
                            <label i18n="@@ContactPopUp_text_phone">Phone Number</label>
                            <input class="form-control" type="text" required #phone="ngModel" mask="(000) 000-0000"
                                [dropSpecialCharacters]="false"
                                [ngClass]="{ 'is-invalid': ((email.invalid && phone.invalid && fax.invalid) && ((phone.dirty || phone.touched) || submitted == true))}"
                                placeholder="Enter Phone Number" i18n-placeholder="@@ContactPopUp_PlaceHolder_phone" [disabled] = "disableInputs"
                                [(ngModel)]="model.phoneNumber" (keypress)="modalEdited = true" />
                            <div *ngIf="(phone.invalid && ((phone.dirty || phone.touched) || submitted == true))"
                                class='invalidInputTextMessage'>
                                <div *ngIf="phone.errors?.['required'] else elsePhone">

                                </div>
                                <ng-template #elsePhone>
                                    <div *ngIf="phone.invalid">
                                        <div i18n="@@ContactPopUp_Error_PhoneInvalid">Phone Number Invalid</div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="mb-3">
                            <label i18n="@@ContactPopUp_text_fax">Fax Number</label>
                            <input class="form-control" type="text" required #fax="ngModel" mask="(000) 000-0000"
                                [dropSpecialCharacters]="false"
                                [ngClass]="{ 'is-invalid': ((email.invalid && phone.invalid && fax.invalid) && ((fax.dirty || fax.touched) || submitted == true))}"
                                placeholder="Enter Fax Number" i18n-placeholder="@@ContactPopUp_PlaceHolder_fax" [disabled] = "disableInputs"
                                [(ngModel)]="model.faxNumber" (keypress)="modalEdited = true" />
                            <div *ngIf="(fax.invalid && ((fax.dirty || fax.touched) || submitted == true))"
                                class='invalidInputTextMessage'>
                                <div *ngIf="fax.errors?.['required'] else elseFax">

                                </div>
                                <ng-template #elseFax>
                                    <div *ngIf="fax.invalid">
                                        <div i18n="@@ContactPopUp_Error_FaxInvalid">Fax Number Invalid</div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>

                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <i class="far fa-user"></i>
                <div i18n="@@ContactPopUp_tab_AddressInfo">Address Information</div>
            </a>
            <ng-template ngbNavContent>
                <app-address [addressModel]="model.address" [submitted]="submitted" (keypress)="modalEdited = true" [disableInputs] = "disableInputs"
                    [includeValidation]="true" (change)="modalEdited = true"></app-address>
            </ng-template>
        </li>

        <li [ngbNavItem]="3" class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <i class="far fa-user"></i>
                <span i18n="@@">Attachments</span>
            </a>

            <ng-template ngbNavContent>
                <span *ngIf="newModel == false">
                    <app-file-management [entityId]="model.id" [entityTypeId]="entityTypeId"
                    [entityName]="model.fullName" ></app-file-management>
                </span>
                <span  *ngIf="newModel == true">
                    <app-file-management [filesIdsToAdd]= "model.fileUpload.fileIdsToAdd" (filesIdsToAddChanged)= "onNewModalEntityFileIdsAdded(model,$event)"
                    [entityName]="model.fullName" [entityFiles]="model.fileUpload.entityFiles"></app-file-management>
                </span>
            </ng-template>

        </li>
        <li *ngIf="newModel == false" [ngbNavItem]="4" class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <i class="far fa-user"></i>
                <span i18n="@@">Recent Activity</span>
            </a>

            <ng-template ngbNavContent>
                <app-timeline-note-list [displayFilterType]="true" [display]="2" [timelineOwnerId]="model.id"></app-timeline-note-list>
            </ng-template>

        </li>

    </ul>


</div>
<div class="card-body p-4  ">

    <div [ngbNavOutlet]="customNav" style=" overflow-y: scroll; overflow-x: hidden; min-height: 28rem; max-height:fit-content; "></div>

    <div *ngIf="disableInputs == false" class="hstack justify-content-end" style="margin-top: 0.5rem;">
        <button [disabled]="disableEditing" *ngIf="(newModel == true) && securityPermissionAccountCreate" type="button"
            class="btn btn-success" id="add-btn" (click)="onSave()"
            i18n="@@ContactPopUp_btn_CreateContact">Create</button>
        <button [disabled]="disableEditing" *ngIf="(newModel == false) && securityPermissionAccountUpdate" type="button"
            class="btn btn-success" id="add-btn" (click)="onSave()"
            i18n="@@ContactPopUp_btn_UpdateContact">Update</button>
    </div>

</div>